import { render, staticRenderFns } from "./selfExamination.vue?vue&type=template&id=8d01af84&scoped=true"
import script from "./selfExamination.vue?vue&type=script&lang=js"
export * from "./selfExamination.vue?vue&type=script&lang=js"
import style0 from "./selfExamination.vue?vue&type=style&index=0&id=8d01af84&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d01af84",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\App_php\\cqjtdx\\cqjtdx_student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d01af84')) {
      api.createRecord('8d01af84', component.options)
    } else {
      api.reload('8d01af84', component.options)
    }
    module.hot.accept("./selfExamination.vue?vue&type=template&id=8d01af84&scoped=true", function () {
      api.rerender('8d01af84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/academicDegree/components/selfExamination.vue"
export default component.exports